import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

/**
 * Whether the user sees the B side of the rooms list improvements.
 * Co-branded brands are excluded from the test: they never evaluate the
 * toggle and always get the current experience. Everyone else is allocated,
 * whatever the room count.
 */
export const useIsRoomsListImprovementsB = (): boolean => {
  const {
    commerce: {coBranded}
  } = useBrandCapabilities()
  const toggle = useToggle()

  return (
    !coBranded.enabled &&
    toggle('fb6c24d6-ap-rooms-list-improvements', false, true)
  )
}
